import '../assets/styles/login.scss';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router';
import LoginImg from '../assets/images/yaong_login.png';
import KakaoIcon from '../assets/icons/kakao-login.png';
import GoogleIcon from '../assets/icons/google-login.png';
import AppleIcon from '../assets/icons/apple-login.png';
import LastLoginTooltip from '../assets/images/last_login_tooltip.png';
import Loading from '../assets/icons/Loading.png';
import { useScript } from '../utils/hooks';
import ToastAlert from '../components/common/Toast';
import { useUnityGameStatus } from './game/yaong-egg/GameProviderEgg';
import ModalDialog from '../components/common/Modal';
import Button from '../components/common/Button';
import useSWR from 'swr';

export default function LoginPage() {
  const { API_SERVER_DOMAIN, signInTest, useAccessToken, appInfo } = useContext(AuthContext);
  const { setGameMode } = useUnityGameStatus();
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState(false);
  const navigate = useNavigate();
  const token = useAccessToken();
  const urlParams = new URLSearchParams(window.location.search);
  const error = urlParams.get('err');
  const [updateOpen, setUpdateOpen] = useState(false);
  const { data: config, isLoading: isConfigLoading } = useSWR(`${API_SERVER_DOMAIN}/auth/config`, (url) =>
    fetch(url).then((res) => res.json()),
  );

  const openOAuthWindow = (snsName) => {
    localStorage.setItem('lastLoginSns', snsName);

    let clientId = '';
    let url = '';
    let redirectUri = encodeURIComponent(`${API_SERVER_DOMAIN}/auth/sso/${snsName}`);

    switch (snsName) {
      case 'kakao':
        clientId = encodeURIComponent('ce14592facabd00d83ba54056aa7117f');
        url = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`;
        break;
      case 'naver':
        clientId = encodeURIComponent('7quR1FTeUB4vxeVfD3FV');
        url = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state==1123`;
        break;
      case 'google':
        clientId = encodeURIComponent('592987376634-pcau3np74emhgs9n04vkcbc48u1ce318.apps.googleusercontent.com');
        url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=email%20profile%20openid&access_type=offline`;
        break;
      case 'apple':
        clientId = encodeURIComponent('app.yaong.com');
        url = `https://appleid.apple.com/auth/authorize?response_type=code%20id_token&response_mode=form_post&scope=name%20email&client_id=${clientId}&redirect_uri=${redirectUri}`;
        break;
    }

    window.location.href = url;
    // window.open(url, 'oauthWindown', 'titlebar=1, resizable=1, scrollbars=yes, width=600, height=650');
  };

  useScript(`${process.env.PUBLIC_URL}/flutter/flutter_script.js`);

  useEffect(() => {
    window.addEventListener('kakaoLoginSuccess', sendTokenToServer);
    // 페이지 이동 시 토큰 로딩 시간동안 로딩 표시
    setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => {
      window.removeEventListener('kakaoLoginSuccess', sendTokenToServer);
    };
  }, []);

  useEffect(() => {
    if (appInfo && config && !isConfigLoading) {
      if (
        (appInfo.os === 'android' &&
          parseFloat(config.infos.android_version) > parseFloat(`${appInfo.version}.${appInfo.buildVersion}`)) ||
        (appInfo.os === 'ios' &&
          parseFloat(config.infos.ios_version) > parseFloat(`${appInfo.version}.${appInfo.buildVersion}`))
      ) {
        // 업데이트 안내
        setUpdateOpen(true);
      } else {
        // 로그인 된 상태면 초기화면으로 이동
        if (!error && token) {
          setGameMode('login'); // 게임 모드 로그인 초기화
          navigate('/playground', { replace: true });
        }

        if (error === 'REREG-RULE-VIOLAT') {
          setAlertMessage('이미 탈퇴 한 아이디예요. 회원가입은 탈퇴일로부터 7일 후 가능해요.');
        }
      }
    }
  }, [appInfo, config, isConfigLoading, error, token]);

  function sendTokenToServer(args) {
    const userInfo = args.detail;
    if (!userInfo) {
      setLoading(false);
    } else {
      let url = `${API_SERVER_DOMAIN}/auth/sso/kakaoApp?code=${userInfo.access_token}`;
      window.location.href = url;
    }
  }

  function login() {
    signInTest('test', '29');
  }

  if (!appInfo || !config) {
    return <div>Loading...</div>;
  }

  return (
    <section className="login-page">
      <h1>야옹상회</h1>
      <p>야무지고 옹골찬 포인트 혜택을 만나보세요.</p>
      <div className="login-actions">
        {loading ? (
          <>
            <LoadingIcon />
            <ModalDialog title="중요한 업데이트가 있어요!" className="update-modal" open={updateOpen}>
              <p>편리한 서비스 이용을 위해 최신 버전으로 업데이트 해주세요.</p>
              <div className="version">
                <div>
                  현재 버전:&nbsp;
                  {appInfo.version + '.' + appInfo.buildVersion}
                </div>
                <div>
                  최신 버전:&nbsp;
                  {appInfo.os === 'android' && config.infos.android_version}
                  {appInfo.os === 'ios' && config.infos.ios_version}
                </div>
              </div>
              <Button
                onClick={() => {
                  let targetUrl = '';
                  if (appInfo.os === 'android') {
                    targetUrl = 'https://play.google.com/store/apps/details?id=com.yaong.app';
                  } else if (appInfo.os === 'ios') {
                    targetUrl =
                      'https://apps.apple.com/kr/app/%EC%95%BC%EC%98%B9%EC%83%81%ED%9A%8C-%EC%89%BD%EA%B3%A0-%EC%A6%90%EA%B1%B0%EC%9A%B4-%ED%8F%AC%EC%9D%B8%ED%8A%B8-%EB%A6%AC%EC%9B%8C%EB%93%9C%EC%95%B1-%EC%95%B1%ED%85%8C%ED%81%AC/id6502283766';
                  }
                  window.location.href = targetUrl;
                }}
              >
                업데이트 하러가기
              </Button>
            </ModalDialog>
          </>
        ) : (
          <>
            <img src={LoginImg} alt="login" style={{ margin: '20px 0' }} />
            <button
              onClick={async () => {
                window.flutter_inappwebview?.callHandler('kakao_login');
                setLoading(true);
                localStorage.setItem('lastLoginSns', 'kakao');

                // openOAuthWindow('kakao');
                // Flag-dev: local web development
                // login();
              }}
            >
              <img src={KakaoIcon} alt="kakao-icon" width={20} />
              <span>카카오로 로그인</span>
              <img
                className={`last-login-tooltip ${localStorage.getItem('lastLoginSns') === 'kakao' ? 'show' : ''}`}
                src={LastLoginTooltip}
                alt="최근에 로그인"
                width={104}
              />
            </button>
            <button
              onClick={() => {
                openOAuthWindow('google');
              }}
            >
              <img src={GoogleIcon} alt="google-icon" width={20} />
              <span>구글로 로그인</span>
              <img
                className={`last-login-tooltip ${localStorage.getItem('lastLoginSns') === 'google' ? 'show' : ''}`}
                src={LastLoginTooltip}
                alt="최근에 로그인"
                width={104}
              />
            </button>
            <button
              onClick={() => {
                openOAuthWindow('apple');
              }}
            >
              <img src={AppleIcon} alt="apple-icon" width={20} />
              <span>Apple로 로그인</span>
              <img
                className={`last-login-tooltip ${localStorage.getItem('lastLoginSns') === 'apple' ? 'show' : ''}`}
                src={LastLoginTooltip}
                alt="최근에 로그인"
                width={104}
              />
            </button>

            <footer>
              가입 시 야옹상회의 서비스
              <a href="https://cream-cushion-517.notion.site/af425ee8e2e144a986305efa80772377?pvs=4" target="_blank">
                이용약관
              </a>
              과{' '}
              <a href="https://plip.kr/pcc/e72d3829-a44c-486a-963d-f027390015b1/consent/3.html" target="_blank">
                개인정보 수집 및 이용
              </a>{' '}
              및{' '}
              <a href="https://plip.kr/pcc/e72d3829-a44c-486a-963d-f027390015b1/consent/4.html" target="_blank">
                제 3자 정보제공
              </a>
              에 동의한 것으로 간주됩니다.
            </footer>
          </>
        )}
      </div>
      <ToastAlert show={!!alertMessage} onClose={setAlertMessage} text={alertMessage} />
    </section>
  );
}

function LoadingIcon() {
  return (
    <div className="loading-circle">
      <img src={Loading} alt="loading" height={24} />
    </div>
  );
}
